import { Link } from "react-router-dom";
import { business } from "@/data/site";

export const waLink = (text = "Ciao! Vorrei avere informazioni su Body Evolution 2.0.") =>
  `https://wa.me/${business.whatsapp}?text=${encodeURIComponent(text)}`;

export const telLink = `tel:${business.phone.replace(/\s/g, "")}`;

export const SectionLabel = ({ children, dark = false, className = "" }) => (
  <div className={`label ${dark ? "text-gold" : "text-gold"} flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-gold/60" />
    {children}
  </div>
);

const base =
  "inline-flex items-center justify-center gap-2 font-body font-semibold text-sm tracking-wide transition-all duration-300 rounded-full px-7 py-3.5";

export const GoldButton = ({ to, href, children, className = "", ...props }) => {
  const cls = `${base} bg-gold text-ink hover:bg-gold-soft hover:shadow-[0_10px_40px_-10px_rgba(197,160,89,0.6)] ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  return <a href={href} className={cls} {...props}>{children}</a>;
};

export const OutlineButton = ({ to, href, children, light = true, className = "", ...props }) => {
  const tone = light
    ? "border border-ivory/40 text-ivory hover:bg-ivory hover:text-ink"
    : "border border-ink-800/30 text-ink-800 hover:bg-ink-800 hover:text-ivory";
  const cls = `${base} ${tone} ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  return <a href={href} className={cls} {...props}>{children}</a>;
};
